import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '@core/api/useApiClient';
import { queryKeys } from '@core/api/queryKeys';
import type { UserProfile } from './useMe';

/**
 * Records a per-user action flag (`POST /api/v1/me/action-flags`) — e.g. dismissing the first-time
 * connect-CQG banner. Idempotent on the BE; the cached /me is patched optimistically in onSuccess so
 * the prompt disappears instantly without a refetch. Only whitelisted keys are accepted server-side
 * (currently just `cqg_connect_prompt_seen` — see ACTION_FLAGS in useMe.ts).
 */
export function useSetActionFlag() {
  const api = useApiClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (flagKey: string) => api.post<void>('/api/v1/me/action-flags', { flagKey }),
    onSuccess: (_data, flagKey) => {
      qc.setQueryData<UserProfile>(queryKeys.me, prev =>
        prev && { ...prev, actionFlags: [...new Set([...(prev.actionFlags ?? []), flagKey])] });
    },
  });
}
